<!--
  Page Title Search Input Component Template

  A simple search input optimized for page titles with search icon.
-->
<ion-input
  [value]="value"
  type="search"
  [id]="undefined"
  [disabled]="disabled"
  [placeholder]="placeholder()"
  [clearInput]="clearInput()"
  [debounce]="debounce()"
  [color]="color()"
  [shape]="shape()"
  [fill]="fill()"
  [mode]="mode()"
  data-lpignore="true"
  autocapitalize="off"
  autocomplete="off"
  autocorrect="off"
  spellcheck="false"
  inputmode="search"
  enterkeyhint="search"
  (ionInput)="onInputChange($event)"
  (ionChange)="onIonChange($event)"
  (click)="onFocusChange($event)"
  (ionBlur)="onBlurChange($event)"
  (keydown.enter)="onEnterPressed($event)"
  [attr.data-lpignore]="'true'"
  class="w-full border-2 rounded-full bg-surface-gradient"
>
  <!-- Search icon at the start -->
  <app-icon slot="start" name="search" size="sm" class="ml-3 text-medium"></app-icon>
  @if (filterButton()) {
  <app-button
    class="!hidden lg:!contents"
    slot="end"
    [color]="filterButtonColor()"
    fill="solid"
    shape="round"

    [shadow]="false"
    [iconOnly]="true"
    ariaLabel="Filter results"
    (click)="
      filterClicked($event); $event.preventDefault(); $event.stopPropagation()
    "
  >
    <app-icon slot="icon-only" size="xs" name="filter"></app-icon>

    <!-- Badge -->
    @if (filterBadge()) {
    <div
      class="absolute top-1.5 right-1 size-3 border-2 bg-danger rounded-full"
    ></div>
    }
    <!-- Filter icon -->
    @if (filterActive()) {
    <div
      class="animated zoomIn absolute top-1.5 right-1 border-2 border-[var(--ion-color-light)] size-3 bg-danger rounded-full"
    ></div>
    }
  </app-button>
  }
</ion-input>
